import {SecurityService} from '../../../components/security';
import {Security} from '../../../models/security';
import {parseSecurityKey, SecurityKey} from '../../../models/security-key';
import {Quote} from './quote';

export const createEmptyQuote = (securityKeyStr: string, securityService: SecurityService): Quote => {
    const securityKey: SecurityKey = parseSecurityKey(securityKeyStr);
    const knownSecurity = securityService.getSecurityFromCacheBySecurityKeyStr(securityKeyStr);

    return {
        securityKeyStr,
        security: knownSecurity || securityKey as Security
    } as Quote;
};
